export default __webpack_public_path__ + "static/media/logo.0244d21f.svg";